import { EnvConfig } from '@shared/definitions';

export const environment: EnvConfig = {
  featureFlags: {},
  production: true,
  staging: false,
  development: false,
  api: 'https://admin.survey-today.com',
  surveyStartUrl: 'https://survey-today.com/survey',
  facebookAppId: '',
  instrumentationKey: 'aa08c151-0241-411b-a74b-dc2e16827a3c',
  recaptchaSiteKey: '6LcDT0klAAAAAMsNvaUGHG2LoQN52p6-UUoMaiWT',
};
